// import { Component } from "app";
// export class PageHeadingComponent extends Component {
//     public selector = "h1.page-heading";
//     public productCategoryHeadingClass = "product-category-page-heading";
//     public OnInit() {
//         if (this.$el.hasClass(this.productCategoryHeadingClass)) {
//             return;
//         }
//         this.$el.ellipsis({
//             ellipClass: "ellip",
//             lines: 3,
//             responsive: true
//         });
//     }
// }
// const pageheading = new PageHeadingComponent();
